import { toggleArrValue } from "utils/functions";
import "./checkbox-group.css";

export default function CheckboxGroup({ name, error, value = [], buttons, max, disabled, style, item_style, onChange }) {

   const onItemChange = ( item_value, btn ) => {
      if ( !onChange ) return;

      if ( max === 1 ) {
         onChange( name, [ item_value ]);
         return;
      }

      if ( max && ( value.length === max ) && !value.includes( item_value )) return;
      onChange( name, toggleArrValue( item_value, value || []), btn );
   } 

   return (
      <div 
         className={ "checkbox-group " + ( disabled ? "disabled" : "" )} 
         style={ style }
         role="group"
      >
         { buttons && buttons.map(({ value: v, label, disabled: item_disabled }) => {

            const checked = value.includes( v );

            return (
               <div
                  key={ v }
                  className={ "checkbox-item" + ( item_disabled ? " disabled" : "" )}
                  style={ item_style }
                  role="checkbox"
                  aria-checked={checked}
                  aria-disabled={disabled || item_disabled}
                  tabIndex={disabled || item_disabled ? -1 : 0}
                  onClick={() => !disabled && !item_disabled && onChange && onItemChange( v, { value: v, label })}
                  onKeyDown={(e) => {
                     if (!disabled && !item_disabled && (e.key === 'Enter' || e.key === ' ')) {
                        e.preventDefault();
                        onItemChange( v, { value: v, label });
                     }
                  }}
               >
                  <div className="checkbox" aria-hidden="true">
                     { checked &&
                        <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <path d="M2 5.94444L7.71429 11.5L18 1.5" strokeWidth="4"/>
                        </svg>
                     }
                  </div>
                  { label }
               </div>
            )
         })}


         { error && <div className="error"> { error } </div> }
      </div>
   )
}